enum Sizes {
  smallest = 0.1,
  extrasmall = 0.5,
  small = 0.9,
  medium = 1,
  large = 1.2,
  xlarge = 1.6,
  extralarge = 1.8,
}

export default Sizes;
